import { useContext } from 'react';
import PropTypes from 'prop-types';
import Player from 'components/core/Player';
import FormPlayerContext from './PlayerContext';

function NewFormPlayer({ asset }) {
    const { setPlayer, setTimeOnSeek } = useContext(FormPlayerContext);
    const { assetType } = asset;
    const isAudioAsset = assetType === 'audio';

    return (
        <div
            data-testid="assetFormPlayer"
            style={
                isAudioAsset
                    ? { position: 'relative', height: '176px' }
                    : { position: 'relative', paddingBottom: '56.25%' }
            }
        >
            <div style={{ position: 'absolute', inset: '0' }}>
                <Player
                    asset={asset}
                    expandHeight={!isAudioAsset}
                    pauseOnSeek
                    onReady={(player) => setPlayer(player)}
                    onSeek={setTimeOnSeek}
                />
            </div>
        </div>
    );
}

NewFormPlayer.propTypes = { asset: PropTypes.object.isRequired };

export default NewFormPlayer;
